import React, { memo, useState } from "react";
import * as Icons from "@mui/icons-material";
import { isAttachmentIconId, loadIcon } from "../../general/loadIcon";

const ActivityIcon = memo(({ iconMui, icon, size = 30 }) => {
  const [imgFailed, setImgFailed] = useState(false);

  const wrapperStyle = {
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
  };

  if (iconMui && isAttachmentIconId(iconMui) && !imgFailed) {
    return (
      <div
        className="flex items-center justify-center shrink-0"
        style={wrapperStyle}
      >
        <img
          src={loadIcon(iconMui)}
          alt=""
          width={size}
          height={size}
          className="object-contain"
          onError={() => setImgFailed(true)}
        />
      </div>
    );
  }

  const IconComponent = iconMui ? Icons[iconMui] : null;
  if (iconMui && IconComponent) {
    return (
      <div
        className="flex items-center justify-center shrink-0"
        style={wrapperStyle}
      >
        <IconComponent style={{ fontSize: size }} />
      </div>
    );
  }

  return (
    <div
      className="flex items-center justify-center shrink-0"
      style={wrapperStyle}
    >
      {icon}
    </div>
  );
});

export default ActivityIcon;
